import React, {useEffect, useRef, useState} from "react";
import PropTypes from "prop-types";

import arrowRight from '../IMAGES/arrowRight.png';
import arrowLeft from '../IMAGES/arrowLeft.png';

const GeneralSlidePlaceArrow = ({x,y,timed,flip}) => {

    const TIME_TO_SHOW_IN_MSECS = 3000;                 // show the arrow this many seconds after removing slide from reader.

    const [showTimer, setShowTimer] = useState(null);

    const arrowRef = useRef(null);

    useEffect( () => {
        return () => { // destructor
            killTimer();
        }
    },[]);  // eslint-disable-line react-hooks/exhaustive-deps

    useEffect( () => {
        if(shouldShowArrow()) {  //set timer if showing
            resetTimer();
        }
        else { // should NOT be showing 
            killTimer();
        }
        
        const a = arrowRef.current;
        a.style.left=x+"px";
        a.style.top=y+"px";
        a.style.display= (shouldShowArrow())?"block":"none";
        
    },[x, y, timed])   // eslint-disable-line react-hooks/exhaustive-deps

    function killTimer() {
        if(showTimer) {
            setShowTimer(null);
            console.debug("SlidePlaceArrow: killing timer early");
            clearTimeout(showTimer);
        }
    }
    
    function resetTimer() {
        killTimer();
        setShowTimer(setTimeout(hideArrow, TIME_TO_SHOW_IN_MSECS));
    }

    function hideArrow() {
        setShowTimer(null);
        if (timed) { // hide only if timed
            if (arrowRef && arrowRef.current) {
                arrowRef.current.style.display = "none"; // hide
            }
        }
    }

    function shouldShowArrow() {
        return (x && x>= 0 && y && y>=0);
    }

    let src=arrowLeft;
    let alt="arrow pointing left";
    if(!flip) {
        src=arrowRight;
        alt="arrow pointing right";
    }
    return(<img id="slideArrow" ref={arrowRef} src={src} className="bounce" alt={alt}/>);
};

GeneralSlidePlaceArrow.propTypes =  {
    x: PropTypes.number,
    y: PropTypes.number,
    timed: PropTypes.bool,
    flip: PropTypes.bool,
}

export default GeneralSlidePlaceArrow;